// 이미지 로드 실패 시 보여줄 대체 이미지
// 파일이 아닌 인라인 SVG라서 대체 이미지 자체가 깨질 일이 없음
const FALLBACK_IMAGE = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300">' +
    '<rect width="400" height="300" fill="#f3f4f6"/>' +
    '<text x="200" y="156" font-family="sans-serif" font-size="18" fill="#9ca3af" text-anchor="middle">이미지를 불러올 수 없습니다</text>' +
    '</svg>'
)}`;

export const handleImageError = (e) => {
  const img = e.currentTarget;
  // 이미 대체 이미지로 바꿨다면 다시 바꾸지 않음 (무한 재요청 방지)
  if (img.getAttribute('src') === FALLBACK_IMAGE) return;
  img.src = FALLBACK_IMAGE;
};
